import Vue from 'vue'
import Vuex from 'vuex'
import cookie from 'js-cookie'

export const TOKEN_COOKIE_NAME = 'fufu counseling app jwt'

Vue.use(Vuex)

function createState() {
  return {
    questions: [],
    token: cookie.get(TOKEN_COOKIE_NAME, {
      secure: process.env.NODE_ENV === 'production',
    }),
    user: null,
  }
}

export default new Vuex.Store({
  state: createState(),
  getters: {
    shop: ({ user }) => user?.shopBase,
    questions: ({ questions, user }) => {
      if (user) {
        let shopId = user.customerShop || '26c0c3a4-21c8-4667-b6b5-674786112e93'
        questions = questions.filter(
          ({ shops }) => shops.length === 0 || shops.includes(shopId)
        )
        questions = questions.map(q => {
          let options = q.options.filter(
            ({ shops }) => shops.length === 0 || shops.includes(shopId)
          )
          return Object.assign({}, q, { options })
        })
      }
      return questions
    },
    token: ({ token }) => token,
    loggedIn: ({ user }) => Boolean(user),
    customerId: ({ user }) => (user && user.customer) || '',
  },
  mutations: {
    CLEAR(state) {
      Object.assign(state, createState())
      cookie.remove(TOKEN_COOKIE_NAME, {
        secure: process.env.NODE_ENV === 'production',
      })
    },
    AUTH(state, { user, token }) {
      state.user = user
      state.token = token
      cookie.set(TOKEN_COOKIE_NAME, token, {
        secure: process.env.NODE_ENV === 'production',
      })
    },
    SET_QUESTIONS(state, questions) {
      questions.forEach(q => {
        q.options = q.options.filter(x => x.isActive)
      })
      state.questions = questions.filter(x => x.isActive)
    },
  },
  actions: {
    clear({ commit }) {
      commit('CLEAR')
    },
    async auth({ commit }, token) {
      const user = await this.$api.auth.getAccount(token)
      commit('AUTH', { user, token })
    },
    async refresh({ getters, commit }) {
      const access = cookie.get(TOKEN_COOKIE_NAME, {
        secure: process.env.NODE_ENV === 'production',
      })
      let token = getters.token || access
      if (!token) return
      try {
        const user = await this.$api.auth.getAccount(token)
        commit('AUTH', { user, token })
      } catch (err) {
        console.error(err)
        commit('CLEAR')
      }
    },
    async fetchQuestions({ commit }) {
      try {
        let { results } = await this.$api.counselingQuestions().list()
        commit('SET_QUESTIONS', results)
      } catch (err) {
        console.error(err)
      }
    },
  },
})
